import styled from '@emotion/styled'
import { Form as AntdForm, Input as AntdInput } from 'antd'
import { Col, Row } from 'antd'
import CommonButton from '@/components/common/Button'

export const RowAntd = styled(Row)``

export const ColAntd = styled(Col)``

export const Button = styled(CommonButton)`
  margin-left: 4px;
`

export const ButtonSuccessStyle = styled(Button)`
  background-color: #009400;
  color: #ffffff !important;
  border: 0;
  font-size: 16px;
`

export const ButtonOutlineDangerStyle = styled(Button)`
  background-color: transparent;
  color: #ff4d4f !important;
  border: 1px solid #ff4d4f !important;

  &:hover {
    border-color: #ff7875 !important;
  }
`

export const Container = styled('div')`
  width: 100%;
  padding: 40px;
  overflow: hidden;
  position: relative;
`

export const Header = styled('div')`
  margin-bottom: 32px;
`

export const SubHeader = styled('div')`
  display: flex;
  justify-content: space-between;
`

export const FormItem = styled(AntdForm.Item)`
  .ant-form-item-label > label.ant-form-item-required::before {
    content: none;
  }
`

export const Input = styled(AntdInput)`
  font-family: 'Prompt';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 16px;
  border-radius: 8px;
`

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 32px;
`
